module.exports = __webpack_public_path__ + "img/mmcb-qrcode.22e04ad3.jpg";